import '../About/about.style.css';
import AboutImg from '../../../../../../img/about.jpg';
import { DobbleCheck } from '../../../../../Icons/Icons';

function About() {
    return (
        <section className='About'>
            <div className='About-image-content'>
                <img src={AboutImg} />
            </div>
            <div className='About-text-content'>
                <h2>Su mejor elección esta con B & M V.I.P</h2>
                <p>En B & M V.I.P contamos con mas de 8 años de experiencia; analizamos y verificamos a quienes desean ofrecer sus servicios en nuestra plataforma</p>
                <p>Nos esmeramos en que la calidad humana en los servicios, marquen una gran diferencia entre nuestros competidores en servicios como:</p>
                <ul>
                    <li>
                        <DobbleCheck />
                        <p>Bartender: Mixologia. Cocteles sin alcohol, Cocteles de autor.</p>
                    </li>
                    <li>
                        <DobbleCheck />
                        <p>Concierge Eventos: Nuestro personal cuentan con experiencia en planeacion de eventos como: Bodas e.t.c...</p>
                    </li>
                    <li>
                        <DobbleCheck />
                        <p>Meseros: Nuestros Meseros manejan etiqueta profesional en cada servicio.</p>
                    </li>
                </ul>
            </div>
            <svg className='Copa' xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="24" viewBox="0 -960 960 960" width="24"><path d="M240-120v-80h200v-200L120-760v-80h720v80L520-400v200h200v80H240Zm58-560h364l72-80H226l72 80Zm182 204 111-124H369l111 124Zm0 0Z"/></svg>
        </section>
    )
}

export default About;